import { RootState } from "state/appStore";
import { useSelector } from "react-redux";

const useRequestStatus = ():string=>{
    const requestStatus = useSelector((state:RootState):string=>{
        return state.request.status;
    });
    return requestStatus;
}
export default useRequestStatus;